import(/* webpackMode: "eager" */ "/home/smartqpro/htdocs/smartq.pro/node_modules/next/dist/client/app-dir/link.js");
